const Footer = () => {
  return (
    <div>
    <footer className="footer">
        <h1 className="footer-title">Direct Connection</h1>
        <div className="footer-copyright">
      <p className="footer-copy-p">&copy; 2026 Direct Connection - 
         Website Created by <a className="footer-face" href="https://www.material-worx.com/portfolio" target="_blank" rel="noopener noreferrer">MX Systems</a> - All Rights Reserved.</p>
    </div>
        </footer>
        </div>
  );
};
export default Footer;
